function About() {
  return (
    <div className="p-6 max-w-4xl mx-auto text-gray-800">
      <h2 className="text-4xl font-bold text-center mb-6">Who We Are</h2>

      {/* Main Description */}
      <div className="bg-white p-6 sm:p-8 rounded-lg shadow-md flex flex-col items-center text-center space-y-6">
        <p className="text-lg leading-relaxed max-w-3xl">
          At <strong>Jake’s RV Repair & Maintenance</strong>, we’re proud to offer honest, reliable, and expert service to RV owners across the Cowichan Valley.
        </p>
        <p className="text-lg leading-relaxed max-w-3xl">
          As a <strong>locally owned and operated business</strong>, we understand the unique needs of West Coast adventurers—and we’re here to keep you rolling.
        </p>
        <p className="text-lg leading-relaxed max-w-3xl">
          Jake works with all types of RVs, trailers, and mobile homes, offering both <strong>on-site mobile service</strong> and <strong>repairs out of our shop</strong>. Whether it’s a seasonal tune-up, a last-minute fix, or regular maintenance, we take pride in doing the job right the first time.
        </p>
        <p className="text-lg leading-relaxed max-w-3xl">
          We believe in treating every customer like a neighbour—because that’s what you are.
        </p>
      </div>

      {/* Meet the Owners */}
      <section className="mt-10 bg-white p-6 sm:p-8 rounded-lg shadow-md text-center flex flex-col items-center">
        <h3 className="text-3xl font-bold mb-4">Meet the Owners</h3>
        <img
          src="/owners.jpeg" // Replace with your actual image file path
          alt="Jake and [Partner Name]"
          className="w-48 h-48 rounded-full object-cover mb-4 shadow"
        />
        <p className="text-lg max-w-2xl">
          Jake and Mackenzie are passionate about helping fellow RVers stay safe and comfortable on the road. With years of hands-on experience and a dedication to craftsmanship, they bring the care and expertise your RV deserves.
        </p>
      </section>

      {/* Google Review CTA */}
      <section className="bg-neutral rounded-xl shadow-md p-6 sm:p-8 mt-10">
        <h2 className="text-3xl font-bold text-center mb-4">Love Our Work?</h2>
        <p className="text-center text-lg text-black mb-6">
          If you’ve worked with us, we’d be grateful if you left a review!
        </p>
        <div className="text-center">
          <a
            href="https://www.google.com/maps/place/Jake's+RV+Repair+and+Maintenance/reviews"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-white text-black font-semibold px-6 py-3 rounded-lg shadow hover:bg-primary transition"
          >
            Leave a Google Review
          </a>
        </div>
      </section>
    </div>
  );
}

export default About;
